exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".branchSelect {\n  margin-bottom: 5px;\n  width: 100%; }\n  .branchSelect .label {\n    display: inline-block;\n    margin-right: 10px; }\n  .branchSelect .select {\n    max-width: 100px;\n    display: inline-block; }\n", ""]);

// exports
